<div class="collapser" [ngClass]="{ 'collapsed' : collapsed, 'opened': !collapsed }" (click)="collapsed = !collapsed">
  <wsb-ui-icon [icon]="collapsed ? 'faCaretRight' : 'faCaretDown'"></wsb-ui-icon>
  <span class="collapser-label" translate>{{ label }}</span>
</div>

<div class="collapsable" [@toggleHeight]="collapsed ? 'hide' : 'show'">
  <ng-content></ng-content>
</div>
